import { INSPECTOR_ELECTROMAGNETIC_SWITCH, INSPECTOR_PROTECTION_RELAY } from "../../../constants/inspectorConstants";
import Symbol from "./Symbol";

class ElectromagneticSwitch extends Symbol {
    constructor({ alias, svgSrc, label, rotable, variants}) {
        super("ElectromagneticSwitch", { alias, svgSrc, label, rotable, variants });

        this.rotable = rotable;
        if (label === 'Relevador de protección') {
            this.attributes = {
                ...this.attributes,
                brand: { isVisible: false, value: null, label: "Marca" },
                model: { isVisible: false, value: null, label: "Modelo" },
                ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
                ratedCurrent: { isVisible: false, value: null, label: "Corriente nominal" },
                interruptingCapacity: { isVisible: false, value: null, label: "Capacidad interruptiva" },
                currentTransformerRatio: { isVisible: false, value: null, label: "Relación de transformadores de corriente (ej. 50/5, 250/5)" },
                tcPrimary: { isVisible: false, value: null, label: "TC Primario (TCP:)" },
                tcSecondary: { isVisible: false, value: null, label: "TC Secundario (TCS:)" },
                ltpu: { isVisible: false, value: null, label: "Pickup de tiempo largo (LTPU)" },
                curveType: { isVisible: false, value: null, label: "Tipo de curva" },
                timeDelay: { isVisible: false, value: null, label: "Retardo de tiempo" },
                shortTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo corto" },
                definiteTime: { isVisible: false, value: null, label: "Tiempo definido" },
                instantaneous: { isVisible: false, value: null, label: "Instantáneo" },
                phaseLongTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo largo" },
                phaseCurveType: { isVisible: false, value: null, label: "Tipo de curva" },
                phaseTimeDelay: { isVisible: false, value: null, label: "Retardo de tiempo" },
                phaseShortTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo corto" },
                phaseDefiniteTime: { isVisible: false, value: null, label: "Tiempo definido" },
                phaseInstantaneous: { isVisible: false, value: null, label: "Instantáneo" },
                groundLongTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo largo" },
                groundCurveType: { isVisible: false, value: null, label: "Tipo de curva" },
                groundTimeDelay: { isVisible: false, value: null, label: "Retardo de tiempo" },
                groundShortTimePickup: { isVisible: false, value: null, label: "Pickup de tiempo corto" },
                groundDefiniteTime: { isVisible: false, value: null, label: "Tiempo definido" },
                groundInstantaneous: { isVisible: false, value: null, label: "Instantáneo" },
                otherProtections: { isVisible: false, value: null, label: "Otras protecciones" },
            };
        }
    }

    getInspector() {
        if (this.label === 'Relevador de protección') {
            return INSPECTOR_PROTECTION_RELAY;
        }
        return INSPECTOR_ELECTROMAGNETIC_SWITCH;
    }
}

export default ElectromagneticSwitch;
